(function () {
  try {
    console.log("✅ monolith-translations.js running", {
      lang: document.documentElement.lang,
      shopifyLocale: window.Shopify && Shopify.locale,
      path: location.pathname
    });

    function isFrench() {
      var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      var shopifyLocale = (window.Shopify && String(Shopify.locale || '').toLowerCase()) || '';
      var path = (location.pathname || '').toLowerCase();

      var pathIsFr = /^\/fr(\/|$)/.test(path) || /^\/fr-ca(\/|$)/.test(path);

      return htmlLang.startsWith('fr') || shopifyLocale.startsWith('fr') || pathIsFr;
    }

    if (!isFrench()) return;

    var REPLACEMENTS = {
      // CUT
      "Regular Fit - Drop 6": "Coupe régulière - Drop 6",
      "Slim Fit - Drop 7": "Coupe ajustée - Drop 7",
      "Regular Fit": "Coupe régulière",
      "Slim Fit": "Coupe ajustée",
      "Trend Fit": "Coupe tendance",
      "Oversize Fit": "Coupe oversize",
      "Comfort Fit": "Coupe confortable",
      "Modern Fit": "Coupe moderne",

      // BADGES
    "2-Piece Set": "Ensemble 2 pièces",
    "3-Piece Set": "Ensemble 3 pièces",
    "Kids": "Enfants",

      // FEATURES
      "Drop 6": "Drop 6",
      "Drop 7": "Drop 7",
      "Notch Lapel": "Revers cranté",
      "Peak Lapel": "Revers en pointe",
      "Flap Pockets": "Poches à rabat",
      "Patch Pockets": "Poches plaquées",
      "Chest Pocket": "Poche-poitrine",
      "Ticket pocket": "Pochette à billets",
      "Elbow Patches": "Coudières",
      "Double Breasted": "Double boutonnage",
      "Long Sleeve": "Manches longues",
      "Short Sleeve": "Manches courtes",
      "Chest Patch Pocket": "Poche-poitrine plaquée",
      "Welt Chest Pocket": "Poche poitrine passepoilée",
      "Shawl Collar with Satin": "Revers en satin",
      "Satin Buttons": "Boutons en satin",
      "Satin on Lapel": "Revers en satin",
      "Inner Vest": "Gilet intérieur",
      "Detachable Collar": "Col amovible",
      "Detachable Double Collar": "Col double amovible",
      "Half Lined": "Demi-doublure",
      "Flap": "Rabat",
      "Semi Spread Collar": "Col mi-ouvert",
      "Soft Construction": "Structure souple",
      "Shoulder Pads": "Épaulettes",
      "Thin Shoulder Pads": "Épaulettes minces",

      // CARE
      "Machine washable": "Lavable en machine",
      "Hang to dry": "Suspendre pour sécher",
      "No bleach": "Pas d'eau de Javel",
      "Low heat iron": "Fer à repasser à basse température",
      "Dry cleaning only": "Nettoyage à sec uniquement",
      "Wash inside out": "Laver à l'envers",
      "Washing max 30°C": "Lavage max 30°C",
      "Wring and hang to dry": "Essorer et suspendre pour sécher",

      // FABRIC
      "Knit": "Tricot",
      "Woven": "Tissé",
      "Wool": "Laine"
    };

    function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function replaceText(text) {
      var output = text;

      var keys = Object.keys(REPLACEMENTS).sort(function (a, b) {
        return b.length - a.length;
      });

      keys.forEach(function (key) {
        var escaped = escapeRegExp(key);
        var pattern = new RegExp("(^|[\\s\\(\\[\\{\\\"'“”‘’.,:;!?/\\\\-])" + escaped + "($|[\\s\\)\\]\\}\\\"'“”‘’.,:;!?/\\\\-])", "g");
        output = output.replace(pattern, function (match, p1, p2) {
          return p1 + REPLACEMENTS[key] + p2;
        });
      });

      return output;
    }

    function walkAndReplace(root) {
      if (!root) return 0;

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          var parent = node.parentNode;
          if (!parent) return NodeFilter.FILTER_REJECT;
          var tag = parent.nodeName;
          if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT" ||
              tag === "TEXTAREA" || tag === "INPUT" ||
              tag === "SELECT" || tag === "OPTION") {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var node;
      var changed = 0;

      while ((node = walker.nextNode())) {
        var updated = replaceText(node.nodeValue);
        if (updated !== node.nodeValue) {
          node.nodeValue = updated;
          changed++;
        }
      }

      return changed;
    }

    function runAll() {
      var total = walkAndReplace(document.body);
      console.log("🔁 translations pass complete — replacements:", total);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        runAll();
        setTimeout(runAll, 300);
        setTimeout(runAll, 1200);
      });
    } else {
      runAll();
      setTimeout(runAll, 300);
      setTimeout(runAll, 1200);
    }

    var observer = new MutationObserver(function () {
      setTimeout(runAll, 50);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

  } catch (e) {
    console.error("❌ monolith-translations.js crashed:", e);
  }
})();